function initCarousel() {
  const desktopCarousel = document.querySelector('.product__media-container.above-mobile.carousel:not(.swiper-initialized)');
  if (!desktopCarousel) return;

  desktopCarousel.classList.add('swiper-initialized');

  const container = desktopCarousel.closest('.product');
  if (!container) return;

  const variantMediaMapEl = document.getElementById(`VariantMediaMap-${container.dataset.sectionId}`);
  let variantMediaMap = {};
  if (variantMediaMapEl) {
    try {
      variantMediaMap = JSON.parse(variantMediaMapEl.textContent);
    } catch (e) {
      console.error("Failed to parse variant media mapping JSON", e);
    }
  }

  if (window.flu && window.flu.chunks && window.flu.chunks.swiper) {
    import(window.flu.chunks.swiper).then(({ Swiper, Pagination, Navigation }) => {
      const desktopFeaturedImage = desktopCarousel.querySelector(".carousel_slide[data-is-featured='true']");
      const initialSlide = desktopFeaturedImage ? parseInt(desktopFeaturedImage.dataset.slideIndex) : 0;

      const swiper = new Swiper(desktopCarousel, {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 4,
        grabCursor: true,
        pagination: {
          el: desktopCarousel.querySelector(".swiper-pagination"),
          type: "bullets",
          clickable: true
        },
        navigation: {
          nextEl: desktopCarousel.querySelector(".swiper-button-next"),
          prevEl: desktopCarousel.querySelector(".swiper-button-prev")
        },
        watchSlidesProgress: true,
        loop: false,
        autoHeight: false,
        initialSlide: initialSlide
      });

      // Synchronize variant change selects
      const form = container.querySelector('[data-product-form]');
      if (form) {
        const handleVariantChange = () => {
          setTimeout(() => {
            const variantSelect = form.querySelector('[data-variant-select]') || form.querySelector('[name="id"]');
            if (variantSelect) {
              const variantId = variantSelect.value;
              const mediaId = variantMediaMap[variantId];
              if (mediaId) {
                const targetSlide = desktopCarousel.querySelector(`[data-media-item-id="${mediaId}"]`);
                if (targetSlide) {
                  const slideIndex = parseInt(targetSlide.dataset.slideIndex);
                  if (!isNaN(slideIndex)) {
                    swiper.slideTo(slideIndex);
                  }
                }
              }
            }
          }, 50);
        };

        form.addEventListener('change', handleVariantChange);
      }
    }).catch(err => {
      console.error("Failed to load Swiper chunk", err);
    });
  }
}

function initMobileCarousel() {
  const mobileCarousel = document.querySelector('.product__media-container.below-mobile.carousel');
  if (!mobileCarousel) return;

  if (mobileCarousel.classList.contains('swiper-initialized-custom')) return;

  if (window.flu && window.flu.chunks && window.flu.chunks.swiper) {
    import(window.flu.chunks.swiper).then(({ Swiper, Pagination, Navigation }) => {
      // Destroy theme.js initialized swiper to prevent conflict
      if (mobileCarousel.swiper) {
        mobileCarousel.swiper.destroy(true, true);
      }

      mobileCarousel.classList.add('swiper-initialized-custom');

      const mobileFeaturedImage = mobileCarousel.querySelector(".carousel_slide[data-is-featured='true']");
      const initialSlide = mobileFeaturedImage ? parseInt(mobileFeaturedImage.dataset.slideIndex) : 0;

      const swiper = new Swiper(mobileCarousel, {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 4,
        grabCursor: true,
        pagination: {
          el: mobileCarousel.querySelector(".swiper-pagination"),
          type: "bullets",
          clickable: true
        },
        navigation: {
          nextEl: mobileCarousel.querySelector(".swiper-button-next"),
          prevEl: mobileCarousel.querySelector(".swiper-button-prev")
        },
        watchSlidesProgress: true,
        loop: false,
        autoHeight: true,
        initialSlide: initialSlide
      });
    }).catch(err => {
      console.error("Failed to load Swiper chunk for mobile carousel", err);
    });
  }
}

function formatYotpoWidget() {
  // console.log("[YotpoRedesign] formatYotpoWidget check started");
  const widgets = document.querySelectorAll('.yotpo-widget-instance');
  if (!widgets.length) {
    // console.log("[YotpoRedesign] No yotpo-widget-instance elements found in DOM");
    return;
  }

  widgets.forEach((widget, index) => {
    const button = widget.querySelector('.yotpo-sr-bottom-line-summary');
    if (!button) {
      // console.log(`[YotpoRedesign] Widget [${index}]: yotpo-sr-bottom-line-summary element not found yet`);
      return;
    }

    // Find the text element specifically by class name (prevents matching stars span screen reader text)
    const textEl = button.querySelector('.yotpo-sr-bottom-line-text');

    if (!textEl) {
      // console.log(`[YotpoRedesign] Widget [${index}]: Reviews count span not found inside button yet`);
      return;
    }

    if (textEl.dataset.formatted) {
      return;
    }

    const ariaLabel = button.getAttribute('aria-label') || '';
    const match = ariaLabel.match(/(\d+)\s+reviews?/i);
    let count = null;
    if (match) {
      count = match[1];
    } else {
      const textContent = textEl.textContent.trim();
      if (textContent.toLowerCase().includes('review')) {
        const textMatch = textContent.match(/\d+/);
        if (textMatch) {
          count = textMatch[0];
        }
      }
    }

    if (count !== null) {
      textEl.innerHTML = `(${count}) <u>See reviews</u>`;
      textEl.dataset.formatted = 'true';
    }
  });
}
function initYotpoWidgets() {
  const widgets = document.querySelectorAll('.yotpo-widget-instance');

  widgets.forEach(widget => {
    if (widget.dataset.yotpoInitialized) {
      if (widget.querySelector('.yotpo-sr-bottom-line-summary')) {
        formatYotpoWidget();
      }
      return;
    }

    widget.dataset.yotpoInitialized = 'true';

    // 1. Try the modern widgets container
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      try {
        window.yotpoWidgetsContainer.initWidgets();
      } catch (e) {
        console.error('[Yotpo AJAX] Error calling yotpoWidgetsContainer.initWidgets:', e);
      }
    }

    // 2. Try the classic yotpo object
    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      try {
        window.yotpo.initWidgets();
      } catch (e) {
        console.error('[Yotpo AJAX] Error calling yotpo.initWidgets:', e);
      }
    } else if (window.yotpo && window.yotpo.widgets && typeof window.yotpo.widgets.init === 'function') {
      try {
        window.yotpo.widgets.init();
      } catch (e) {
        console.error('[Yotpo AJAX] Error calling yotpo.widgets.init:', e);
      }
    }

    // 3. Try legacy API refresh
    if (typeof Yotpo !== 'undefined' && Yotpo && typeof Yotpo.API === 'function') {
      try {
        var api = new Yotpo.API(window.yotpo);
        if (api && typeof api.refreshWidgets === 'function') {
          api.refreshWidgets();
        }
      } catch (e) {
        console.error('[Yotpo AJAX] Error calling Yotpo.API.refreshWidgets:', e);
      }
    }

    // Keep observing to format on initial load and any subsequent Yotpo re-renders
    const observer = new MutationObserver(() => {
      formatYotpoWidget();
    });

    observer.observe(widget, {
      childList: true,
      subtree: true
    });
  });
}

function initOverviewTabs() {
  // console.log("[OverviewTabs] initOverviewTabs check started");

  const triggers = document.querySelectorAll('.overview-tab-trigger:not(.overview-tab-faq-link):not(.js-tabs-initialized)');
  triggers.forEach(trigger => {
    trigger.classList.add('js-tabs-initialized');
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      const content = trigger.nextElementSibling;

      // Close all other accordions
      document.querySelectorAll('.overview-tab-trigger:not(.overview-tab-faq-link)').forEach(item => {
        if (item !== trigger) {
          item.setAttribute('aria-expanded', 'false');

          const panel = item.nextElementSibling;
          if (panel) {
            panel.style.display = 'none';
          }
        }
      });

      // Toggle current accordion
      if (isExpanded) {
        trigger.setAttribute('aria-expanded', 'false');
        if (content) content.style.display = 'none';
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        if (content) content.style.display = 'block';
      }
    });
  });

  const faqLinks = document.querySelectorAll('.overview-tab-faq-link:not(.js-tabs-initialized)');
  faqLinks.forEach(faqLink => {
    faqLink.classList.add('js-tabs-initialized');
  });
}

// Global Event Delegation for Overview FAQ link clicks
document.addEventListener('click', function(e) {
  const faqLink = e.target.closest('.overview-tab-faq-link');
  if (!faqLink) return;

  e.preventDefault();

  const rawTarget = faqLink.dataset.anchorClass || faqLink.dataset.anchorTarget || 'faq-accordion-section';
  const cleanTarget = rawTarget.replace(/^\./, '').replace(/^#/, '');

  let targetEl = document.querySelector(`.${cleanTarget}`) 
    || document.querySelector(`[class*="${cleanTarget}"]`) 
    || document.getElementById(cleanTarget)
    || document.querySelector(`[id*="${cleanTarget}"]`)
    || document.querySelector('.faq-accordion-section')
    || document.querySelector('.section-faq')
    || document.querySelector('.faq-section')
    || document.querySelector('[class*="faq-accordion"]')
    || document.querySelector('[class*="faq"]');

  if (targetEl) {
    const headerHeight = document.querySelector('.site-header, header, [data-site-header], .header-wrapper')?.offsetHeight || 80;
    const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerHeight - 20;

    window.scrollTo({
      top: Math.max(0, offsetPosition),
      behavior: 'smooth'
    });
  }
});

function initYotpoOnce() {
  const observer = new MutationObserver(() => {
    const widgets = document.querySelectorAll('.yotpo-widget-instance');

    widgets.forEach(widget => {
      if (widget.dataset.yotpoInitialized) {
        formatYotpoWidget();
        return;
      }

      const rendered = widget.querySelector('.yotpo-sr-bottom-line-summary');

      if (!rendered && window.yotpoWidgetsContainer) {
        widget.dataset.yotpoInitialized = "true";

        if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
          window.yotpoWidgetsContainer.initWidgets();
        }

        const widgetObserver = new MutationObserver(() => {
          formatYotpoWidget();
        });
        widgetObserver.observe(widget, { childList: true, subtree: true });

        setTimeout(() => {
          formatYotpoWidget();
        }, 100);
      }

      if (rendered) {
        formatYotpoWidget();
        const widgetObserver = new MutationObserver(() => {
          formatYotpoWidget();
        });
        widgetObserver.observe(widget, { childList: true, subtree: true });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function initAllRedesignFeatures() {
  initCarousel();
  initMobileCarousel();
  initOverviewTabs();
  initAjaxLinkedProducts();
  initResultMediaSliders();
  initYotpoWidgets();
  initYotpoOnce();
}

// Initialize on DOMContentLoaded or immediately if DOM is already parsed
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllRedesignFeatures);
} else {
  initAllRedesignFeatures();
}


document.addEventListener('shopify:section:load', () => {
  initCarousel();
  initMobileCarousel();
  formatYotpoWidget();
  initOverviewTabs();
  initResultMediaSliders();

  initYotpoWidgets();
});

// Observe DOM insertions to re-initialize Swiper and format Yotpo widget
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      const hasCarousel = Array.from(mutation.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches('.carousel') || node.querySelector('.carousel'))
      );
      if (hasCarousel) {
        initCarousel();
        initMobileCarousel();
      }

      const hasResultSlider = Array.from(mutation.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches('.result-swiper-main') || node.querySelector('.result-swiper-main'))
      );
      if (hasResultSlider) {
        initResultMediaSliders();
      }

      const hasOverviewTabs = Array.from(mutation.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches('.overview-tab-item') || node.querySelector('.overview-tab-item'))
      );
      if (hasOverviewTabs) {
        initOverviewTabs();
      }

      formatYotpoWidget();
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });

/**
 * Re-wires [data-option-buttons] swatch/chip button groups so clicking a button
 * updates the hidden <select> and fires a change event. This mirrors what the
 * theme's OptionButtons / createOptionGroup does in theme.js, but runs
 * synchronously right after an AJAX DOM swap — before ProductForm's async
 * getProduct() callback has had a chance to subscribe.
 */
function reinitOptionButtons(container) {
  const groups = container.querySelectorAll('[data-option-buttons]');
  console.log('[PDP AJAX] reinitOptionButtons: found', groups.length, 'option-button groups');
  groups.forEach(function (group) {
    const select = group.querySelector('select');
    const buttons = Array.from(group.querySelectorAll('[data-button]'));
    console.log('[PDP AJAX] group:', group, '| select:', !!select, '| buttons:', buttons.length);
    if (!select || !buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const optionHandle = btn.dataset.optionHandle;
        console.log('[PDP AJAX] btn click: optionHandle=', optionHandle);

        // Update selected class
        buttons.forEach(function (b) {
          b.classList.toggle('selected', b.dataset.optionHandle === optionHandle);
        });

        // Update the hidden select option
        const opt = select.querySelector('[data-value-handle="' + optionHandle + '"]');
        console.log('[PDP AJAX] matching select option:', opt);
        if (opt) {
          opt.selected = true;
          // Fire change so ProductForm (and dynamic-options) picks it up
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
}

function initAjaxLinkedProducts() {
  document.body.addEventListener('click', function (e) {
    const link = e.target.closest('a.linked-product-row');
    if (!link) return;

    e.preventDefault();
    const url = link.getAttribute('href');
    if (!url) return;

    const mainSection = document.querySelector('.product') &&
      document.querySelector('.product').closest('[id^="shopify-section-"]');
    if (!mainSection) return;

    let sectionId = mainSection.id.replace('shopify-section-', '');

    mainSection.style.opacity = '0.5';
    mainSection.style.pointerEvents = 'none';
    mainSection.style.transition = 'opacity 0.3s ease';

    // Build fetch URL: we fetch the full page to retrieve other product-specific sections
    let fetchUrl = url;
    const currentParams = new URLSearchParams(window.location.search);
    const previewThemeId = currentParams.get('preview_theme_id');
    if (previewThemeId) {
      fetchUrl += (fetchUrl.includes('?') ? '&' : '?') + 'preview_theme_id=' + previewThemeId;
    }

    fetch(fetchUrl)
      .then(response => response.text())
      .then(html => {
        history.pushState({ path: url }, '', url);

        // Unload old section instance
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && window.Shopify.theme.sections.instances) {
          const oldIdx = window.Shopify.theme.sections.instances.findIndex(inst => inst.id === sectionId);
          if (oldIdx !== -1) {
            const oldInstance = window.Shopify.theme.sections.instances[oldIdx];
            if (typeof oldInstance.onUnload === 'function') {
              try { oldInstance.onUnload(); } catch (e) { /* ignore unload errors */ }
            }
            window.Shopify.theme.sections.instances.splice(oldIdx, 1);
          }
        }

        // Parse the full page HTML and inject the inner content
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // 1. Swap main section
        const responseSection = doc.getElementById('shopify-section-' + sectionId);
        if (responseSection) {
          mainSection.innerHTML = responseSection.innerHTML;
        } else {
          const found = doc.querySelector(`[id*="${sectionId}"]`);
          if (found) {
            mainSection.innerHTML = found.innerHTML;
          } else {
            mainSection.innerHTML = html;
          }
        }

        // 2. Identify and swap all other product-specific sections on the page
        const productSpecificSectionKeywords = [
          'comparison_vs', 'comparison-vs',
          'ingredients_grid', 'ingredients-grid',
          'benefits_split', 'benefits-split',
          'faq_accordion', 'faq-accordion',
          'result_media_slider', 'result-media-slider',
          'recommended_products', 'recommended-products'
        ];

        const sectionsToSwap = [];

        // Check for sections matching keywords
        document.querySelectorAll('.shopify-section').forEach(sec => {
          if (sec.id) {
            const matchesKeyword = productSpecificSectionKeywords.some(keyword => sec.id.toLowerCase().includes(keyword));
            if (matchesKeyword) {
              sectionsToSwap.push(sec);
            }
          }
        });

        // Check for Yotpo main reviews widget section dynamically
        const yotpoMainWidget = document.querySelector('#yotpo-reviews-main-widget') || 
                                document.querySelector('.yotpo-reviews-main-widget') ||
                                Array.from(document.querySelectorAll('.yotpo-widget-instance')).find(w => !w.closest('.product'));
        if (yotpoMainWidget) {
          const yotpoSec = yotpoMainWidget.closest('.shopify-section');
          if (yotpoSec && yotpoSec.id && !sectionsToSwap.includes(yotpoSec)) {
            sectionsToSwap.push(yotpoSec);
          }
        }

        function reinitShopifySectionInstance(secElement) {
          if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections && window.Shopify.theme.sections.registered) {
            const container = secElement.querySelector('[data-section-type]');
            if (container) {
              const sectionType = container.getAttribute('data-section-type');
              const SectionConstructor = window.Shopify.theme.sections.registered[sectionType];
              if (SectionConstructor) {
                try {
                  // Unload old instance first if it exists
                  const oldIdx = window.Shopify.theme.sections.instances.findIndex(inst => inst.id === secElement.id.replace('shopify-section-', ''));
                  if (oldIdx !== -1) {
                    const oldInstance = window.Shopify.theme.sections.instances[oldIdx];
                    if (typeof oldInstance.onUnload === 'function') {
                      try { oldInstance.onUnload(); } catch (e) {}
                    }
                    window.Shopify.theme.sections.instances.splice(oldIdx, 1);
                  }
                  // Load new instance
                  const newInstance = new SectionConstructor(container);
                  window.Shopify.theme.sections.instances.push(newInstance);
                  console.log('[PDP AJAX] Re-initialized Shopify section instance:', sectionType);
                } catch (err) {
                  console.error('[PDP AJAX] Error re-initializing section ' + sectionType + ':', err);
                }
              }
            }
          }
        }

        // Perform the swap for each section
        sectionsToSwap.forEach(oldSec => {
          const isRecommendations = oldSec.id.includes('recommended') || oldSec.querySelector('[data-recommendations]') || oldSec.querySelector('[data-section-type="recommended-products"]');
          
          if (isRecommendations) {
            const sectionId = oldSec.id.replace('shopify-section-', '');
            // Get new product ID
            const newProductContainer = doc.querySelector('[data-product-id]');
            const productId = newProductContainer ? newProductContainer.getAttribute('data-product-id') : null;
            
            if (productId) {
              const rootPath = window.Shopify.routes ? window.Shopify.routes.root : '/';
              const limit = oldSec.querySelector('[data-limit]') ? oldSec.querySelector('[data-limit]').getAttribute('data-limit') : 4;
              const recommendationsUrl = `${rootPath}recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;
              
              console.log('[PDP AJAX] Fetching new recommendations from:', recommendationsUrl);
              fetch(recommendationsUrl)
                .then(res => res.text())
                .then(html => {
                  const parser = new DOMParser();
                  const recDoc = parser.parseFromString(html, 'text/html');
                  const recSec = recDoc.getElementById(oldSec.id);
                  if (recSec) {
                    oldSec.innerHTML = recSec.innerHTML;
                    console.log('[PDP AJAX] Recommendations content swapped successfully.');
                    
                    // Re-initialize section in Shopify theme instances if registered
                    reinitShopifySectionInstance(oldSec);
                  }
                })
                .catch(err => console.error('[PDP AJAX] Failed to fetch product recommendations:', err));
            }
          } else {
            const newSec = doc.getElementById(oldSec.id);
            if (newSec) {
              // Remove noscript tags to prevent the browser from rendering fallback SEO metadata text dynamically
              newSec.querySelectorAll('noscript').forEach(ns => ns.remove());
              
              oldSec.innerHTML = newSec.innerHTML;
              
              // Clear initialized dataset markers to allow re-initialization
              delete oldSec.dataset.yotpoInitialized;
              const widgets = oldSec.querySelectorAll('.yotpo-widget-instance');
              widgets.forEach(w => {
                delete w.dataset.yotpoInitialized;
              });

              // Re-initialize section in Shopify theme instances if registered
              reinitShopifySectionInstance(oldSec);
            }
          }
        });

        mainSection.style.opacity = '1';
        mainSection.style.pointerEvents = 'auto';

        // --- Re-initialize option buttons IMMEDIATELY (synchronous) ---
        // This ensures swatch clicks work even before ProductForm's async setup.
        reinitOptionButtons(mainSection);

        // --- Re-initialize the full theme product section (async, handles price etc.) ---
        if (window.Shopify && window.Shopify.theme &&
          window.Shopify.theme.sections && window.Shopify.theme.sections.registered &&
          window.Shopify.theme.sections.registered.product) {
          const newContainer = mainSection.querySelector('[data-section-type="product"]');
          if (newContainer) {
            try {
              const ProductSectionConstructor = window.Shopify.theme.sections.registered.product;
              const newInstance = new ProductSectionConstructor(newContainer);
              window.Shopify.theme.sections.instances.push(newInstance);
            } catch (err) {
              console.error('[PDP AJAX] Error re-initializing product section:', err);
            }
          }
        }

        initCarousel();
        initMobileCarousel();
        initOverviewTabs();
        initResultMediaSliders();
        initYotpoWidgets();
        initPriceObservers();
        updateVariantSaveBadges();
        document.querySelectorAll('.product').forEach(updateProductHeaderPrices);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(error => {
        console.error('[PDP AJAX] Fetch error:', error);
        window.location.href = url;
      });
  });
}

function initResultMediaSliders() {
  const allContainers = document.querySelectorAll('.result-swiper-main');
  console.log('[Results Media Slider] initResultMediaSliders called. Total .result-swiper-main found on page:', allContainers.length);
  allContainers.forEach((c, idx) => {
    console.log('[Results Media Slider] Container #' + idx + ' ID:', c.id, 'Classes:', c.className);
  });

  const mainContainers = document.querySelectorAll('.result-swiper-main:not(.swiper-initialized)');
  if (mainContainers.length === 0) {
    console.log('[Results Media Slider] No uninitialized Swiper containers found. Exiting.');
    return;
  }

  if (typeof Swiper === 'undefined') {
    console.log('[Results Media Slider] Swiper is undefined, retrying in 100ms...');
    setTimeout(initResultMediaSliders, 100);
    return;
  }

  console.log('[Results Media Slider] Initializing ' + mainContainers.length + ' main Swiper containers...');
  
  mainContainers.forEach(container => {
    container.classList.add('swiper-initialized');
    const slidesMobile = parseFloat(container.dataset.mobile || 1.5);
    const slidesTablet = parseFloat(container.dataset.tablet || 3);
    const slidesDesktop = parseFloat(container.dataset.desktop || 5.5);
    
    const mainSwiper = new Swiper(container, {
      slidesPerView: slidesMobile,
      spaceBetween: 16,
      grabCursor: true,
      navigation: {
        nextEl: '.result-btn-next',
        prevEl: '.result-btn-prev',
      },
      breakpoints: {
        320: {
          centeredSlides: true,
          spaceBetween: 20
        },
        600: {
          slidesPerView: slidesTablet,
          spaceBetween: 20
        },
        960: {
          slidesPerView: slidesDesktop,
          spaceBetween: 24
        }
      }
    });

    // Initialize Lightbox Slider
    const sectionWrapper = container.closest('.shopify-section') || document.body;
    
    const lightboxContainer = sectionWrapper.querySelector('.result-swiper-lightbox');
    let lightboxSwiper = null;
    if (lightboxContainer) {
      if (!lightboxContainer.classList.contains('swiper-initialized')) {
        lightboxContainer.classList.add('swiper-initialized');
        console.log('[Results Media Slider] Initializing lightbox Swiper...');
        lightboxSwiper = new Swiper(lightboxContainer, {
          slidesPerView: 1,
          spaceBetween: 30,
          grabCursor: true,
          navigation: {
            nextEl: '.result-lightbox-btn-next',
            prevEl: '.result-lightbox-btn-prev',
          },
          on: {
            slideChange: function() {
              const videos = sectionWrapper.querySelectorAll('.result-lightbox-video');
              videos.forEach(video => video.pause());
              
              const activeSlide = this.slides[this.activeIndex];
              const activeVideo = activeSlide.querySelector('.result-lightbox-video');
              if (activeVideo) {
                activeVideo.play().catch(e => console.log("Auto-play blocked", e));
              }
            }
          }
        });
      } else {
        console.log('[Results Media Slider] Lightbox Swiper already initialized, retrieving instance');
        lightboxSwiper = lightboxContainer.swiper;
      }
    } else {
      console.warn('[Results Media Slider] lightboxContainer not found');
    }

    const modal = sectionWrapper.querySelector('.result-lightbox-modal');
    if (modal) {
      const closeBtn = modal.querySelector('.result-lightbox-close');
      const slideItems = sectionWrapper.querySelectorAll('.result-slide-item');
      console.log('[Results Media Slider] Found modal. Bindings count:', slideItems.length);

      slideItems.forEach(item => {
        const newListener = function() {
          const index = parseInt(this.dataset.mediaIndex);
          console.log('[Results Media Slider] Slide item clicked, index:', index);
          modal.setAttribute('aria-hidden', 'false');
          modal.classList.add('active');
          document.body.style.overflow = 'hidden';
          
          if (lightboxSwiper) {
            console.log('[Results Media Slider] Sliding lightbox to index:', index);
            lightboxSwiper.update();
            lightboxSwiper.slideTo(index, 0);
            
            const activeSlide = lightboxSwiper.slides[index];
            const activeVideo = activeSlide.querySelector('.result-lightbox-video');
            if (activeVideo) {
              activeVideo.play().catch(e => console.log("Auto-play blocked", e));
            }
          } else {
            console.warn('[Results Media Slider] lightboxSwiper instance is null/undefined during click');
          }
        };
        item.removeEventListener('click', item._lightboxListener);
        item.addEventListener('click', newListener);
        item._lightboxListener = newListener;
      });

      const closeModal = () => {
        console.log('[Results Media Slider] Closing modal');
        modal.setAttribute('aria-hidden', 'true');
        modal.classList.remove('active');
        document.body.style.overflow = '';
        
        const videos = sectionWrapper.querySelectorAll('.result-lightbox-video');
        videos.forEach(video => {
          video.pause();
          video.currentTime = 0;
        });
      };

      if (closeBtn) {
        closeBtn.removeEventListener('click', closeBtn._closeListener);
        closeBtn.addEventListener('click', closeModal);
        closeBtn._closeListener = closeModal;
      }
      
      modal.removeEventListener('click', modal._modalClickListener);
      const modalClickListener = function(e) {
        if (e.target === modal) closeModal();
      };
      modal.addEventListener('click', modalClickListener);
      modal._modalClickListener = modalClickListener;

      // Add keyboard support
      document.removeEventListener('keydown', window._lightboxKeydownListener);
      window._lightboxKeydownListener = function(e) {
        if (modal.classList.contains('active')) {
          if (e.key === 'Escape') closeModal();
          if (e.key === 'ArrowRight' && lightboxSwiper) lightboxSwiper.slideNext();
          if (e.key === 'ArrowLeft' && lightboxSwiper) lightboxSwiper.slidePrev();
        }
      };
      document.addEventListener('keydown', window._lightboxKeydownListener);
    } else {
      console.warn('[Results Media Slider] modal not found');
    }
  });
}

function updateVariantSaveBadges() {
  const onetimeBadges = document.querySelectorAll('.variant-save-badge.onetime-badge, .product-badge.onetime-badge');
  const subBadges = document.querySelectorAll('.variant-save-badge.sub-badge, .product-badge.sub-badge');

  // Create a Set of distinct badge containers to process them independently
  const containers = new Set();

  [...onetimeBadges, ...subBadges].forEach(badge => {
    // Find the closest meaningful container (Quick View modal or main product form)
    const container = badge.closest('.quick-view-modal__content, .product, .product-container, form[action*="/cart/add"], .main-product') || document;
    containers.add(container);
  });

  containers.forEach(container => {
    // Check if this container is the recommendation quick view
    const isRecQuickView = container.classList && container.classList.contains('quick-view-modal__content') && window.isRecommendationQuickView;

    let isSubscription = false;

    if (isRecQuickView) {
      isSubscription = false; // Force one-time purchase badge for recommendation popup
    } else {
      const planPicker = container.querySelector('skio-plan-picker');
      if (planPicker) {
        isSubscription = planPicker.selectedSellingPlan !== null && planPicker.selectedSellingPlan !== undefined;
      } else {
        const subRadio = container.querySelector('input[data-smartrr-selling-plan-group-input]:checked, input[name="purchase_option"]:checked');
        if (subRadio && subRadio.value !== '') {
          isSubscription = true;
        } else if (!subRadio) {
          const sellingPlanInput = container.querySelector('input[name="selling_plan"]');
          if (sellingPlanInput && sellingPlanInput.value && sellingPlanInput.value.trim() !== '') {
            isSubscription = true;
          }
        }
      }
    }

    const containerOnetimeBadges = container.querySelectorAll('.variant-save-badge.onetime-badge, .product-badge.onetime-badge');
    const containerSubBadges = container.querySelectorAll('.variant-save-badge.sub-badge, .product-badge.sub-badge');

    // Grab dynamically calculated badge texts for the selected variant IN THIS CONTAINER
    const selectedVariantBtn = container.querySelector('.product__option-button.selected');
    if (selectedVariantBtn) {
      const mainOnetimeText = selectedVariantBtn.getAttribute('data-product-badge-onetime');
      const mainSubText = selectedVariantBtn.getAttribute('data-product-badge-sub');

      container.querySelectorAll('.product-badge.onetime-badge').forEach(badge => {
        if (mainOnetimeText && mainOnetimeText.trim() !== '') {
          badge.innerText = mainOnetimeText;
          badge.style.display = isSubscription ? 'none' : '';
        } else {
          badge.style.display = 'none';
        }
      });

      container.querySelectorAll('.product-badge.sub-badge').forEach(badge => {
        if (mainSubText && mainSubText.trim() !== '') {
          badge.innerText = mainSubText;
          badge.style.display = isSubscription ? '' : 'none';
        } else {
          badge.style.display = 'none';
        }
      });

      // Toggle the small variant badges inside the buttons
      container.querySelectorAll('.variant-save-badge.onetime-badge').forEach(badge => {
        badge.style.display = isSubscription ? 'none' : '';
      });
      container.querySelectorAll('.variant-save-badge.sub-badge').forEach(badge => {
        badge.style.display = isSubscription ? '' : 'none';
      });
      // Keep the per-pack price on each tile in step with the badge (one-time vs subscription)
      container.querySelectorAll('.variant-perpack--onetime').forEach(el => {
        const hasSub = el.parentElement && el.parentElement.querySelector('.variant-perpack--sub');
        el.style.display = (isSubscription && hasSub) ? 'none' : 'block';
      });
      container.querySelectorAll('.variant-perpack--sub').forEach(el => {
        el.style.display = isSubscription ? 'block' : 'none';
      });
    } else {
      // Fallback if no variant button is found
      containerOnetimeBadges.forEach(badge => {
        badge.style.display = isSubscription ? 'none' : '';
      });
      containerSubBadges.forEach(badge => {
        badge.style.display = isSubscription ? '' : 'none';
      });
      container.querySelectorAll('.variant-perpack--onetime').forEach(el => {
        const hasSub = el.parentElement && el.parentElement.querySelector('.variant-perpack--sub');
        el.style.display = (isSubscription && hasSub) ? 'none' : 'block';
      });
      container.querySelectorAll('.variant-perpack--sub').forEach(el => {
        el.style.display = isSubscription ? 'block' : 'none';
      });
    }
  });
}

document.addEventListener('click', (e) => {
  const quickViewBtn = e.target.closest('[data-quick-shop-trigger="quick-view"]');
  if (quickViewBtn) {
    if (quickViewBtn.closest('.recommended-products-v2')) {
      window.isRecommendationQuickView = true;
    } else {
      window.isRecommendationQuickView = false;
    }
  }
  setTimeout(updateVariantSaveBadges, 150);
}, true);
document.addEventListener('change', (e) => {
  setTimeout(updateVariantSaveBadges, 100);
}, true);
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(updateVariantSaveBadges, 500);

  let checks = 0;
  const interval = setInterval(() => {
    updateVariantSaveBadges();
    checks++;
    if (checks > 10) clearInterval(interval);
  }, 500);

  // Observe DOM changes in case Shopify AJAX replaces the HTML when a variant is clicked
  const formObserver = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    for (const m of mutations) {
      if (m.type === 'childList' && m.addedNodes.length > 0) {
        // Only trigger update if it looks like a meaningful DOM update in the product area
        const hasProductUpdates = Array.from(m.addedNodes).some(node =>
          node.nodeType === 1 && (node.classList?.contains('product-badges') || node.querySelector('.product-badge, .variant-save-badge'))
        );
        if (hasProductUpdates) {
          shouldUpdate = true;
          break;
        }
      }
    }
    if (shouldUpdate) {
      initPriceObservers();
      setTimeout(updateVariantSaveBadges, 150);
    }
  });

  formObserver.observe(document.body, { childList: true, subtree: true });
});

function formatMoney(cents) {
  const formatString = (window.theme && window.theme.moneyFormat) || "£{{amount}}";
  
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return "0";
    }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split(".");
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    const centsVal = parts[1] ? decimal + parts[1] : "";
    return dollars + centsVal;
  }

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const match = formatString.match(placeholderRegex);
  if (!match) return formatString;

  switch (match[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ",");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

function updateProductHeaderPrices(container) {
  const planPicker = container.querySelector('skio-plan-picker');
  if (!planPicker || !planPicker.product || !planPicker.selectedVariant) return;

  const variant = planPicker.selectedVariant;
  const plan = planPicker.selectedSellingPlan;

  // Calculate price and compare-at price
  const compareAt = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
  let finalPrice = variant.price;

  if (plan) {
    const adj = plan.price_adjustments && plan.price_adjustments[0];
    if (adj) {
      if (adj.value_type === 'percentage') {
        finalPrice = variant.price - Math.round((variant.price * adj.value) / 100);
      } else if (adj.value_type === 'fixed_amount') {
        finalPrice = variant.price - adj.value;
      } else if (adj.value_type === 'price') {
        finalPrice = adj.value;
      }
    }
  }

  // Update data-price
  container.querySelectorAll('.product__price [data-price]').forEach(el => {
    el.innerHTML = formatMoney(finalPrice);
  });

  // Update data-compare-price
  let displayComparePrice = 0;
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    displayComparePrice = variant.compare_at_price;
  } else if (plan && finalPrice < variant.price) {
    displayComparePrice = variant.price;
  }

  container.querySelectorAll('.product__price [data-compare-price]').forEach(el => {
    if (displayComparePrice > 0) {
      el.innerHTML = formatMoney(displayComparePrice);
      el.style.display = '';
    } else {
      el.innerHTML = '';
      el.style.display = 'none';
    }
  });

  // Update discount display
  const hasDiscount = compareAt > 0 && compareAt > finalPrice;
  const percent = hasDiscount ? Math.round(((compareAt - finalPrice) / compareAt) * 100) : 0;
  
  container.querySelectorAll('.product__price [data-discount-display]').forEach(el => {
    const text = percent + '% off' + (hasDiscount ? ' · Save ' + formatMoney(compareAt - finalPrice).replace(/<[^>]*>/g, '') : '');
    el.textContent = hasDiscount ? '(' + text + ')' : '';
    el.style.display = hasDiscount ? '' : 'none';
  });

  // Update sale badge
  container.querySelectorAll('.product-badge--sale').forEach(el => {
    if (!hasDiscount) {
      el.textContent = '';
      el.style.display = 'none';
      return;
    }
    const existing = (el.textContent || '').toLowerCase();
    const prefix = existing.indexOf('up to') !== -1 ? 'Save up to ' : 'Save ';
    el.textContent = prefix + percent + '%';
    el.style.display = '';
  });
}

function initPriceObservers() {
  document.querySelectorAll('.product').forEach(container => {
    const priceEl = container.querySelector('.product__price');
    if (!priceEl || priceEl.dataset.priceObserverActive) return;
    priceEl.dataset.priceObserverActive = 'true';

    const observer = new MutationObserver(() => {
      observer.disconnect();
      updateProductHeaderPrices(container);
      updateVariantSaveBadges();
      observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
    });
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });
  });
}

// Global Event Listeners for Plan Picker updates and Variant Switches
document.addEventListener('skio::update-selling-plan', function (e) {
  const picker = document.querySelector(`skio-plan-picker[key="${e.detail.key}"]`);
  const container = picker ? picker.closest('.product') : null;
  if (container) {
    updateVariantSaveBadges();
    updateProductHeaderPrices(container);
  }
});

document.addEventListener('change', (e) => {
  setTimeout(() => {
    updateVariantSaveBadges();
    document.querySelectorAll('.product').forEach(updateProductHeaderPrices);
  }, 100);
}, true);

document.addEventListener('DOMContentLoaded', () => {
  initPriceObservers();
  setTimeout(() => {
    updateVariantSaveBadges();
    document.querySelectorAll('.product').forEach(updateProductHeaderPrices);
  }, 500);
});

/* RFWT: Subscribe & Save savings badge shows the 20% subscription discount (Skio defaults to RRP) */
(function(){
  function fix(){ return; /* RFWT 28Oct: override disabled; Skio shows native RRP-based saving */
    document.querySelectorAll('skio-plan-picker').forEach(function(p){
      var r = p.shadowRoot; if(!r) return; if(p.selectedVariant && p.selectedVariant.price){ var w=(p.selectedVariant.price/100).toFixed(2); r.querySelectorAll('.skio-price-row s').forEach(function(s){ var c=s.textContent||''; var n=c.replace(/[\d.,]+/, w); if(c!==n) s.textContent=n; }); }
      r.querySelectorAll('.savings.bubble').forEach(function(el){
        var t = el.textContent || '';
        if(/\d+%/.test(t) && t.indexOf('20%') === -1){ el.textContent = t.replace(/\d+%/, '20%'); }
      });
    });
  }
  function start(p){ if(p.shadowRoot && !p._rfwtSkioObs){ var o = new MutationObserver(fix); o.observe(p.shadowRoot, {childList:true, subtree:true, characterData:true}); p._rfwtSkioObs = o; fix(); } }
  function init(){ document.querySelectorAll('skio-plan-picker').forEach(start); fix(); }
  var n = 0, iv = setInterval(function(){ init(); if(++n > 25) clearInterval(iv); }, 700);
  document.addEventListener('DOMContentLoaded', init);
})();
